import { render, staticRenderFns } from "./TeacherShow.vue?vue&type=template&id=7a99f218&"
import script from "./TeacherShow.vue?vue&type=script&lang=js&"
export * from "./TeacherShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports